module.exports = __webpack_public_path__ + "static/media/backrise-60.68102d5a.png";